import { isEvent } from "./event.js";
const FUNCTION = "function";
const isPublicFunction = (value, fnName) => typeof value === FUNCTION && !!fnName && !fnName.startsWith("_");
class ScriptingObject {
  /**
   * unique id of the scripting object
   */
  #id;
  /**
   * type of the scripting object
   */
  #objectType = "Object";
  /**
   * Creates an instance of ScriptingObject.
   * @param objectId unique id of the scripting object
   * @param objectType type of the scripting object
   */
  constructor(objectId, objectType) {
    this.#id = objectId;
    this.#objectType = objectType || this.#objectType;
  }
  /**
   * get unique id of the scripting object
   */
  get id() {
    return this.#id;
  }
  /**
   * get type of the scripting object
   */
  get objectType() {
    return this.#objectType;
  }
  /**
   * transform the scripting object to a format suitable for transmitting over window.postMessage
   * @returns marshalled scripting object
   */
  // eslint-disable-next-line no-underscore-dangle
  _toJSON = () => {
    const functions = [];
    const events = [];
    Object.keys(this).forEach((property) => {
      const value = this[property];
      if (isEvent(value)) {
        events.push(property);
      } else if (isPublicFunction(value, property)) {
        functions.push(property);
      }
    });
    return {
      objectId: this.#id,
      objectType: this.#objectType,
      functions,
      events
    };
  };
  /**
   * dispose the scripting object
   */
  // eslint-disable-next-line no-underscore-dangle
  _dispose = () => {
  };
  /**
   * dispose the scripting object
   */
  dispose = () => {
  };
}
export {
  ScriptingObject,
  isPublicFunction
};
